import { render, staticRenderFns } from "./ClaimOptions.vue?vue&type=template&id=21722b86"
import script from "./ClaimOptions.vue?vue&type=script&lang=js"
export * from "./ClaimOptions.vue?vue&type=script&lang=js"
import style0 from "./ClaimOptions.vue?vue&type=style&index=0&id=21722b86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports